var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallSoundOf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1022_26691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.38333C11.25 2.27 9.90334 1.7125 9.11667 2.5L5.36667 6.25H3.75667C2.80584 6.25 1.82501 6.80333 1.54001 7.8375C1.34665 8.54204 1.24911 9.26941 1.25001 10C1.25001 10.7483 1.35084 11.4733 1.54167 12.1625C1.82584 13.1958 2.80667 13.75 3.75751 13.75H5.36584L9.11584 17.5C9.90334 18.2875 11.25 17.73 11.25 16.6167V3.38333ZM14.8167 7.68333C14.7595 7.62193 14.6905 7.57268 14.6138 7.53852C14.5371 7.50436 14.4544 7.48599 14.3704 7.48451C14.2865 7.48303 14.2032 7.49846 14.1253 7.5299C14.0475 7.56133 13.9768 7.60812 13.9175 7.66747C13.8581 7.72682 13.8113 7.79751 13.7799 7.87534C13.7485 7.95316 13.733 8.03652 13.7345 8.12044C13.736 8.20435 13.7544 8.28712 13.7885 8.36378C13.8227 8.44045 13.8719 8.50945 13.9333 8.56667L15.3667 10L13.9333 11.4333C13.8229 11.5518 13.7628 11.7085 13.7657 11.8704C13.7686 12.0324 13.8341 12.1868 13.9487 12.3014C14.0632 12.4159 14.2177 12.4815 14.3796 12.4843C14.5415 12.4872 14.6982 12.4271 14.8167 12.3167L16.25 10.8833L17.6833 12.3167C17.7406 12.3781 17.8096 12.4273 17.8862 12.4615C17.9629 12.4956 18.0457 12.514 18.1296 12.5155C18.2135 12.517 18.2968 12.5015 18.3747 12.4701C18.4525 12.4387 18.5232 12.3919 18.5825 12.3325C18.6419 12.2732 18.6887 12.2025 18.7201 12.1247C18.7515 12.0468 18.767 11.9635 18.7655 11.8796C18.764 11.7956 18.7457 11.7129 18.7115 11.6362C18.6773 11.5596 18.6281 11.4906 18.5667 11.4333L17.1333 10L18.5667 8.56667C18.6771 8.44819 18.7372 8.29148 18.7343 8.12957C18.7315 7.96765 18.6659 7.81316 18.5514 7.69865C18.4368 7.58414 18.2824 7.51854 18.1204 7.51569C17.9585 7.51283 17.8018 7.57293 17.6833 7.68333L16.25 9.11667L14.8167 7.68333Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1022_26691",
    x: 0.25,
    y: 1.13129,
    width: 19.5156,
    height: 17.7374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_26691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_26691",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallSoundOf);
export default __webpack_public_path__ + "static/media/SmallSoundOf.7a543b16564e5e10ff40b89c3ec473ee.svg";
export { ForwardRef as ReactComponent };